import { render, staticRenderFns } from "./NoConfiguration.vue?vue&type=template&id=ff1f015a&scoped=true&"
import script from "./NoConfiguration.vue?vue&type=script&lang=ts&"
export * from "./NoConfiguration.vue?vue&type=script&lang=ts&"
import style0 from "./NoConfiguration.vue?vue&type=style&index=0&id=ff1f015a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1f015a",
  null
  
)

export default component.exports